import React from "react";

// Custom Tooltip component to show date
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        }}
      >
        <p style={{ margin: "0 0 8px 0", fontWeight: 600, color: "#1a1a1a" }}>
          {label} - {data.date}
        </p>
        {payload.map((entry, index) => (
          <p key={index} style={{ margin: "4px 0", color: entry.color }}>
            {entry.name}: {entry.value.toLocaleString()}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default CustomTooltip;
